import React from 'react';
import PropTypes from 'prop-types';

class ListItem extends React.PureComponent {
  render() {
    let { children, component: ComponentProp, className, ...other } = this.props;
    const Component = ComponentProp || 'li';

    return (
      <Component className={className} {...other}>
        {children}
      </Component>
    );
  }
}

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  component: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const ListItem = ({prop = val, className = '', component = 'li' }) =>

export default ListItem;
